import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref } from "vue";
import Multiselect from "vue-multiselect";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatabaseEditTab',
    props: {
        genomes: null,
        databaseKeyFromElements: null
    },
    emits: ["clicked-save"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedGenome = ref();
        function clickedSave() {
            emit("clicked-save", "dbkey", selectedGenome.value);
        }
        onMounted(() => {
            selectedGenome.value = props.genomes.find((element) => element.id == props.databaseKeyFromElements);
        });
        return { __sfc: true, props, emit, selectedGenome, clickedSave, Multiselect, localize };
    }
});
